import styled from 'styled-components';
import { useMemo } from 'react';
import { FolderManagerMimeTypes } from '../../../interfaces';
import { SlidesViewFilters } from './FolderManagerSlidesViewFilters';

//region INTERFACES
export interface IOnItemUploadPayload {
  files: FileList;
  item: FolderManagerItem | null;
}

export interface FolderManagerGridViewProps {
  items: FolderManagerItem[];
  selectedRows: FolderManagerItem[];
  noDataMessage?: string;
  onDragEnd: (data: any) => void;
  onDoubleClick: (data: any) => void;
  onSelect: (data: any) => void;
  onAction: (data: IOnAction<IActionItemPayload | IOnItemUploadPayload>) => void;
  onDragStart: (data: any) => void;
  isLoading: boolean;

  disableUpload?: boolean;
  minHeight?: string;
  disableInternalDnD?: boolean;
  acceptedDragTypes?: string[];
  viewStateKey?: string;
  slidesViewEnabled?: boolean;
  showThemePicker?: boolean;
  onAddSlide?: (slide: any) => void;
  onSelectionChange?: (items: any[]) => void;
  zoomValue?: number;
  disableSelection?: boolean;
  filters?: SlidesViewFilters;
  onFiltersChange?: (filters: SlidesViewFilters) => void;
}

export interface GridViewProps {
  items: FolderManagerItem[];
  selectedRows: FolderManagerItem[];
  noDataMessage?: string;
  overId?: string;
  isLoading: boolean;
  disableUpload?: boolean;
  acceptedDragTypes?: string[];
  viewStateKey?: string;
  slidesViewEnabled?: boolean;
  showThemePicker?: boolean;
  onAction: (data: any) => void;
  onSelect: (data: any) => void;
  onDoubleClick: (data: any) => void;
  onAddSlide?: (slide: any) => void;
  onSelectionChange?: (items: any[]) => void;
  zoomValue?: number;
  disableSelection?: boolean;
  filters?: SlidesViewFilters;
}

export interface StyledGridViewProps {
  $columnsCount?: number;
}

export interface GridViewData {
  folders: FolderManagerItem[];
  workspaces: FolderManagerItem[];
  assets: FolderManagerItem[];
}
//endregion

//region STYLED
export const StyledGridContainer = styled.div`
  position: relative;

  .type-header {
    font-size: ${({ theme }) => theme.fontSize.h5};
    color: ${({ theme }) => theme.palette.gray};
  }
`;

export const StyledGridView = styled.div<StyledGridViewProps>`
  padding: 0;
  display: grid;
  grid-template-columns: repeat(${({ $columnsCount }) => $columnsCount || 4}, 1fr);
  gap: 20px;
`;

//endregion

//region HOOKS
export const useGridViewData = (items: FolderManagerItem[]): GridViewData => {
  return useMemo(() => {
    return items.reduce(
      (acc: GridViewData, item: FolderManagerItem) => {
        if (item.type === FolderManagerMimeTypes.FOLDER) {
          acc.folders.push(item);
        } else if (item.type === FolderManagerMimeTypes.WORKSPACE) {
          acc.workspaces.push(item);
        } else {
          acc.assets.push(item);
        }
        return acc;
      },
      { folders: [], assets: [], workspaces: [] },
    );
  }, [items]);
};
//endregion
